import React from 'react';

/**
 * Zoom controls for the Day-view timeline window.
 * Three buttons: Focus 2h (±1h around now), Business 8AM–8PM, Full day.
 * Jump-to-time picker dropped — prev/next arrows + date navigation at
 * the outer header cover that need.
 */

const btnBase = {
  padding: '6px 10px',
  borderRadius: '6px',
  border: '1px solid var(--border-default, #e7e5e4)',
  backgroundColor: 'var(--surface-raised, #fff)',
  color: 'var(--text-default)',
  fontSize: '11px',
  fontWeight: 600,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

const btnActive = {
  ...btnBase,
  backgroundColor: 'var(--gold-500, #c8a147)',
  color: '#fff',
  borderColor: 'var(--gold-500, #c8a147)',
};

const TimeWindowControls = ({ mode, onChange }) => {
  const applyFocus = () => onChange({ mode: 'focus' });
  const applyBusiness = () => onChange({ mode: 'business' });
  const applyFull = () => onChange({ mode: 'full' });

  return (
    <div style={{ display: 'flex', gap: '6px', alignItems: 'center', position: 'relative' }}>
      <button
        type="button"
        style={mode === 'focus' ? btnActive : btnBase}
        onClick={applyFocus}
        title="Zoom to ±1 hour around now — tightest detail"
      >
        Focus 2h
      </button>
      <button
        type="button"
        style={mode === 'business' ? btnActive : btnBase}
        onClick={applyBusiness}
        title="8 AM to 8 PM"
      >
        Business 8AM–8PM
      </button>
      <button
        type="button"
        style={mode === 'full' ? btnActive : btnBase}
        onClick={applyFull}
        title="Full 24 hours"
      >
        Full day
      </button>
    </div>
  );
};

export default TimeWindowControls;
